import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthContextProvider } from './store/AuthContext.js';
import { SidebarContextProvider } from './store/SidebarContext.js';

const resizeObserverErrorPattern = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;

window.addEventListener('error', (event) => {
  if (resizeObserverErrorPattern.test(event.message || '')) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reasonMessage = String(event.reason?.message || event.reason || '');
  if (resizeObserverErrorPattern.test(reasonMessage)) {
    event.preventDefault();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <SidebarContextProvider>
        <App />
      </SidebarContextProvider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
